// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerOfferItem')
class Orders__CustomerOfferItem {
    @jsonProperty(() => Orders__CustomerOfferItem.Id)
    id: Orders__CustomerOfferItem.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "quantities", "requestItem", "requestItemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "quantities", "requestItem", "requestItemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "quantities", "requestItem", "requestItemId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "offer": "Orders.CustomerOffer", "offerId": "Orders.CustomerOffer.Id", "quantities": "Orders.CustomerOfferItemQuantity[]", "requestItem": "Orders.CustomerRequestItem", "requestItemId": "Orders.CustomerRequestItem.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ offer: () => Orders.CustomerOffer } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ quantities: () => Orders.CustomerOfferItemQuantity } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({ requestItem: () => Orders.CustomerRequestItem } as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θoffer = Signals.proxySignalDeferred<Orders.CustomerOffer>(() => (undefined) as any);
    private readonly θofferId = Signals.proxySignalDeferred<Orders.CustomerOffer.Id>(() => (undefined) as any);
    private readonly θquantities = Signals.proxySignalDeferred<Orders.CustomerOfferItemQuantity[]>(() => (undefined) as any);
    private readonly θrequestItem = Signals.proxySignalDeferred<Orders.CustomerRequestItem>(() => (undefined) as any);
    private readonly θrequestItemId = Signals.proxySignalDeferred<Orders.CustomerRequestItem.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerOfferItem' {
        return 'Orders.CustomerOfferItem'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerOfferItem' {
        return 'Orders.CustomerOfferItem'
    }

    static get __baseType(): 'Orders.CustomerOfferItem' {
        return 'Orders.CustomerOfferItem'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerOfferItem' {
        return 'Orders.CustomerOfferItem'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerOfferItem[BoInfoSymbol]
    }

    get offer(): Orders.CustomerOffer {
        return this.θoffer?.()
    }

    set offer(offer) {
        this.θoffer.set(coerceDataType(offer, Orders.CustomerOffer, false, true))
        if (offer) {
            this.θofferId.set(offer.id)
        } else if (offer === null && offer) {
            this.θofferId.set(null)
        }
    }

    get offerId(): Orders.CustomerOffer.Id {
        return this.θofferId?.()
    }

    set offerId(offerId) {
        if (offerId === null) this.θoffer.set(null)
        if (this.offer?.id && offerId != this.offer.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θofferId.set(coerceDataType(offerId, 'Orders.CustomerOffer.Id', false, true))
    }

    get quantities(): Orders.CustomerOfferItemQuantity[] {
        return this.θquantities?.()
    }

    set quantities(quantities) {
        this.θquantities.set(coerceDataType(quantities, Orders.CustomerOfferItemQuantity, true, true))
        this.quantities?.forEach?.(item => { if (item && "offerItem" in item) item.offerItem = this as any })
    }

    get requestItem(): Orders.CustomerRequestItem {
        return this.θrequestItem?.()
    }

    set requestItem(requestItem) {
        this.θrequestItem.set(coerceDataType(requestItem, Orders.CustomerRequestItem, false, true))
        if (requestItem) {
            this.θrequestItemId.set(requestItem.id)
        } else if (requestItem === null && requestItem) {
            this.θrequestItemId.set(null)
        }
    }

    get requestItemId(): Orders.CustomerRequestItem.Id {
        return this.θrequestItemId?.()
    }

    set requestItemId(requestItemId) {
        if (requestItemId === null) this.θrequestItem.set(null)
        if (this.requestItem?.id && requestItemId != this.requestItem.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestItemId.set(coerceDataType(requestItemId, 'Orders.CustomerRequestItem.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerOfferItem>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                quantities: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerOfferItem()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerOfferItem>, restrictToClass?: Class<Partial<Orders__CustomerOfferItem>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('offer', 'offerId', 'quantities', 'requestItem', 'requestItemId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerOfferItem {
        return equal(this, other)
    }
}

namespace Orders__CustomerOfferItem { }

export import CustomerOfferItem = Orders__CustomerOfferItem
setTimeout(() => {
    jsonProperty(() => Orders.CustomerOffer)(Orders__CustomerOfferItem.prototype, 'offer')
    jsonProperty(() => Orders.CustomerOffer.Id)(Orders__CustomerOfferItem.prototype, 'offerId')
    jsonArrayProperty(() => Orders.CustomerOfferItemQuantity)(Orders__CustomerOfferItem.prototype, 'quantities')
    jsonProperty(() => Orders.CustomerRequestItem)(Orders__CustomerOfferItem.prototype, 'requestItem')
    jsonProperty(() => Orders.CustomerRequestItem.Id)(Orders__CustomerOfferItem.prototype, 'requestItemId')
    jsonProperty(() => Date)(Orders__CustomerOfferItem.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItem.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerOfferItem.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItem.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerOfferItem.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItem.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerOfferItem.prototype, 'versionNumber')
})

export const CustomerOfferItemθId = Number;

export type CustomerOfferItemθId = number;

namespace Orders__CustomerOfferItem {
    export type Id = NominalType<number, 'Orders.CustomerOfferItem'>

}
